<template>
  <div class="ShainTorokuJocho">
    <el-dialog :title="dialogTitle" :visible="shainJochoDialogVisible" @open="onOpen" @close="onClose" width="800px" top="6vh">
      <el-form :model="form" id="shainjohoJochoForm" label-width="150px" ref="shainjohoJochoForm" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item label="ﾒｰﾙｱﾄﾞﾚｽ">
              <el-input v-model="form.shainId" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="社員氏名">
              <el-input v-model="form.shainShimei" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="基準始業･終業時刻" :error="errors.kijunJikoku">
              <el-input v-model="form.kijunShigyoJikoku" type="time" class="half-input"></el-input>
              <el-input v-model="form.kijunShugyoJikoku" type="time" class="half-input"></el-input>
            </el-form-item>
            <el-form-item label="昼食開始･終了時刻">
              <el-input v-model="form.chushokuKaishiJikoku" type="time" class="half-input"></el-input>
              <el-input v-model="form.chushokuShuryoJikoku" type="time" class="half-input"></el-input>
            </el-form-item>
            <el-form-item label="休憩開始･終了時刻">
              <el-input v-model="form.kyukeiKaishiJikoku" type="time" class="half-input"></el-input>
              <el-input v-model="form.kyukeiShuryoJikoku" type="time" class="half-input"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上長ﾒｰﾙｱﾄﾞﾚｽ1" :error="errors.jochoShainId">
              <el-input v-model="form.jochoShainId" maxlength="50" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="上長ﾒｰﾙｱﾄﾞﾚｽ2" :error="errors.jochoShainId2">
              <el-input v-model="form.jochoShainId2" maxlength="50" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="上長ﾒｰﾙｱﾄﾞﾚｽ3" :error="errors.jochoShainId3">
              <el-input v-model="form.jochoShainId3" maxlength="50" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="営業ﾒｰﾙｱﾄﾞﾚｽ1" :error="errors.eigyoShainId">
              <el-input v-model="form.eigyoShainId" maxlength="50" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="営業ﾒｰﾙｱﾄﾞﾚｽ2" :error="errors.eigyoShainId2">
              <el-input v-model="form.eigyoShainId2" maxlength="50" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="営業ﾒｰﾙｱﾄﾞﾚｽ3" :error="errors.eigyoShainId3">
              <el-input v-model="form.eigyoShainId3" maxlength="50" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="残業承認者">
              <el-input v-model="form.zangyoShoninshaSei" maxlength="10" placeholder="姓" class="half-input"></el-input>
              <el-input v-model="form.zangyoShoninshaMei" maxlength="10" placeholder="名" class="half-input"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">キャンセル</el-button>
        <el-button type="primary" @click="onRegister('shainjohoJochoForm')">登録</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { notifySuccess, notifyError } from '../utils.js'

export default {
  name: 'ShainTorokuJocho',
  props: ['shainJochoDialogVisible', 'shain'],
  data() {
    return {
      form: {
        shainId: '',
        shainShimei: '',
        kijunShigyoJikoku: '',
        kijunShugyoJikoku: '',
        chushokuKaishiJikoku: '',
        chushokuShuryoJikoku: '',
        kyukeiKaishiJikoku: '',
        kyukeiShuryoJikoku: '',
        jochoShainId: '',
        jochoShainId2: '',
        jochoShainId3: '',
        eigyoShainId: '',
        eigyoShainId2: '',
        eigyoShainId3: '',
        zangyoShoninshaSei: '',
        zangyoShoninshaMei: '',
      },
      errors: {
        kijunJikoku: '',
        jochoShainId: '',
        jochoShainId2: '',
        jochoShainId3: '',
        eigyoShainId: '',
        eigyoShainId2: '',
        eigyoShainId3: '',
      },
      loading: true
    }
  },
  computed: {
    dialogTitle() {
      return `${this.form.shainShimei}さんの社員設定`;
    },
  },
  methods: {
    onOpen() {
      this.loading = true;
      this.errors = {
        kijunJikoku: '',
        jochoShainId: '',
        jochoShainId2: '',
        jochoShainId3: '',
        eigyoShainId: '',
        eigyoShainId2: '',
        eigyoShainId3: '',
      };
      this.$axios.get('/gwr/shain/shain/' + this.shain.shainId)
        .then((response) => {
          this.form.shainId = response.data.shainId;
          this.form.shainShimei = response.data.shainShimei;
          this.form.kijunShigyoJikoku = response.data.kijunShigyoJikoku;
          this.form.kijunShugyoJikoku = response.data.kijunShugyoJikoku;
          this.form.chushokuKaishiJikoku = response.data.chushokuKaishiJikoku;
          this.form.chushokuShuryoJikoku = response.data.chushokuShuryoJikoku;
          this.form.kyukeiKaishiJikoku = response.data.kyukeiKaishiJikoku;
          this.form.kyukeiShuryoJikoku = response.data.kyukeiShuryoJikoku;
          this.form.jochoShainId = response.data.jochoShainId;
          this.form.jochoShainId2 = response.data.jochoShainId2;
          this.form.jochoShainId3 = response.data.jochoShainId3;
          this.form.eigyoShainId = response.data.eigyoShainId;
          this.form.eigyoShainId2 = response.data.eigyoShainId2;
          this.form.eigyoShainId3 = response.data.eigyoShainId3;
          this.form.zangyoShoninshaSei = response.data.zangyoShoninshaSei;
          this.form.zangyoShoninshaMei = response.data.zangyoShoninshaMei;
          this.targetRow = this.shain;
          this.loading = false;
        })
        .catch((error) => {
          notifyError(this, error, 'データ取得エラー');
        });
    },
    validateJocho: async function(shainId) {
      let result = false;
      this.loading = true;
      try {
        let response = await this.$axios.get('/gwr/shain/validateJocho/' + shainId)
        result = response.data;
      }
      catch (error) {
        notifyError(this, error, 'データ取得エラー');
      }
      this.loading = false;
      return result;
    },
    onRegister(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.errors = {
            kijunJikoku: '',
            jochoShainId: '',
            jochoShainId2: '',
            jochoShainId3: '',
            eigyoShainId: '',
            eigyoShainId2: '',
            eigyoShainId3: '',
          }
          let hasError = false;
          if (!this.form.kijunShigyoJikoku || !this.form.kijunShugyoJikoku) {
            this.errors.kijunJikoku = '基準始業･終業時刻を入力してください。';
            hasError = true;
          }
          if (this.form.jochoShainId && !(await this.validateJocho(this.form.jochoShainId))) {
            this.errors.jochoShainId = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.jochoShainId2 && !(await this.validateJocho(this.form.jochoShainId2))) {
            this.errors.jochoShainId2 = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.jochoShainId3 && !(await this.validateJocho(this.form.jochoShainId3))) {
            this.errors.jochoShainId3 = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.eigyoShainId && !(await this.validateJocho(this.form.eigyoShainId))) {
            this.errors.eigyoShainId = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.eigyoShainId2 && !(await this.validateJocho(this.form.eigyoShainId2))) {
            this.errors.eigyoShainId2 = '登録されていないアドレスです。';
            hasError = true;
          }
          if (this.form.eigyoShainId3 && !(await this.validateJocho(this.form.eigyoShainId3))) {
            this.errors.eigyoShainId3 = '登録されていないアドレスです。';
            hasError = true;
          }
          if (hasError) {
            this.$notify({
              title: '入力エラー',
              message: '入力欄に表示されているエラー内容を確認してください。',
              type: 'error'
            });
            return;
          }
          this.loading = true;
          let params = new URLSearchParams();
          params.append('shainId', this.form.shainId ?? '');
          params.append('kijunShigyoJikoku', this.form.kijunShigyoJikoku ?? '');
          params.append('kijunShugyoJikoku', this.form.kijunShugyoJikoku ?? '');
          params.append('chushokuKaishiJikoku', this.form.chushokuKaishiJikoku ?? '');
          params.append('chushokuShuryoJikoku', this.form.chushokuShuryoJikoku ?? '');
          params.append('kyukeiKaishiJikoku', this.form.kyukeiKaishiJikoku ?? '');
          params.append('kyukeiShuryoJikoku', this.form.kyukeiShuryoJikoku ?? '');
          params.append('jochoShainId', this.form.jochoShainId ?? '');
          params.append('jochoShainId2', this.form.jochoShainId2 ?? '');
          params.append('jochoShainId3', this.form.jochoShainId3 ?? '');
          params.append('eigyoShainId', this.form.eigyoShainId ?? '');
          params.append('eigyoShainId2', this.form.eigyoShainId2 ?? '');
          params.append('eigyoShainId3', this.form.eigyoShainId3 ?? '');
          params.append('zangyoShoninshaSei', this.form.zangyoShoninshaSei ?? '');
          params.append('zangyoShoninshaMei', this.form.zangyoShoninshaMei ?? '');
          this.$axios.patch('/gwr/shain/shainJoho', params)
              .then(() => {
                notifySuccess(this, '更新完了', '社員情報を更新しました。');
              })
              .catch((error) => {
                notifyError(this, error, 'データ更新エラー');
              });
          this.onClose();
        } else {
          return false;
        }
      });
    },
    onClose() {
      this.$emit('close-shain-jocho-dialog');
    }
  }
}
</script>

<style scoped>
#shainjohoJochoForm >>> .el-input {
  width: 220px !important;
}
.el-button {
  margin: 0px 1px !important;
}
#shainjohoJochoForm >>> .half-input {
  width: 110px !important;
}
#shainjohoJochoForm >>> .el-input__inner {
  font-family: inherit !important;
}
.ShainTorokuJocho >>> .el-dialog__body {
  padding-top: 10px !important;
  padding-bottom: 0 !important;
}
.ShainTorokuJocho >>> .el-dialog__footer {
  margin-top: -10px !important;
}
</style>